import {__isAvailable} from "./utility.helper";

export const urlHelper = {
	getDomainFragments,
	checkUrlDomain,
	getUrlWithoutParams,
	isUrlRootSame
};

/**
 * This function takes in a url and attempts to parse it into smaller chunks
 *
 * @param url the url to probe
 * @returns {parseDomain.ParsedDomain | *} smaller chunks (sub-domain, domain, tld)
 */
function getDomainFragments(url) {
	const parseDomain = require("parse-domain");
	return parseDomain(url);
}

/**
 * This function takes in the current url and determines if it is localhost or ip based
 *
 * @param url the url to probe
 * @returns {{isLocalOrIp: boolean, fragments: (parseDomain.ParsedDomain|*)}}
 * isLocalOrIp indicates whether localhost or ip-based
 * fragments contains domain fragments, null if ip or localhost
 */
function checkUrlDomain(url) {
	const fragments = getDomainFragments(url);
	return { isLocalOrIp: fragments === null, fragments: fragments }
}

/**
 * Accepts a url and removes the search parameters
 *
 * @param url the url to be trimmed
 * @returns {*} url without the search parameters
 */
function getUrlWithoutParams(url) {
	const stringUtils = require('underscore.string');
	return stringUtils.strLeft(url, "?");
}

/**
 * Checks equality of roots of two given urls
 *
 * @param url1 url 1
 * @param url2 url 2
 * @return {boolean} whether given urls are equal or not
 */
function isUrlRootSame(url1, url2) {
	const parseDomain = require("parse-domain");
	const url1Values = parseDomain(url1);
	const url2Values = parseDomain(url2);
	
	return __isAvailable(url1Values) && __isAvailable(url2Values)
			&& url1Values.domain === url2Values.domain
			&& url1Values.subdomain === url2Values.subdomain
			&& url1Values.tld === url2Values.tld;
}